import React from 'react';

const FeaturesSection = () => {
    return (
        <section className="features-section" id="features">
            <div className="bg-glow bg-glow-1"></div>
            <div className="bg-glow bg-glow-2"></div>

            <div className="container">
                <div className="section-header reveal">
                    <div className="section-eyebrow">Vendor Toolkit</div>
                    <h2>A Complete Toolkit for Salon Growth</h2>
                    <p>Look inside the Vendor module designed to save you time and maximize bookings.</p>
                </div>

                <div className="features-grid">
                    <div className="feature-card reveal">
                        <div className="fc-icon color-bookings"><i className="fa-solid fa-calendar-days"></i></div>
                        <h3>Booking List</h3>
                        <p>Filter reservations by All, Pending, or Complete. Easily manage multi-service appointments from
                            clients like Rahul with full paid/unpaid status tracking.</p>
                    </div>
                    <div className="feature-card reveal" style={{ transitionDelay: '0.1s' }}>
                        <div className="fc-icon color-expenses"><i className="fa-solid fa-wallet"></i></div>
                        <h3>Expense Tracker</h3>
                        <p>Log all overhead. Filter spending dynamically by month (e.g. April 2026) to view detailed Total
                            Amount vs Paid Amount summaries.</p>
                    </div>
                    <div className="feature-card reveal" style={{ transitionDelay: '0.2s' }}>
                        <div className="fc-icon color-attendance"><i className="fa-solid fa-user-clock"></i></div>
                        <h3>Staff Attendance</h3>
                        <p>Dedicated tracking for each employee (e.g., Select Employee: Pratik). Log daily
                            Check-in/Check-out times and instantly mark Absent or Present.</p>
                    </div>
                    <div className="feature-card reveal" style={{ transitionDelay: '0.1s' }}>
                        <div className="fc-icon color-services"><i className="fa-solid fa-scissors"></i></div>
                        <h3>Dynamic Services</h3>
                        <p>Create and categorize offerings (O3+ Bridal Facial, Hydra Brightening). Set exact durations,
                            prices, and maintain active status toggles.</p>
                    </div>
                    <div className="feature-card reveal" style={{ transitionDelay: '0.2s' }}>
                        <div className="fc-icon color-customers"><i className="fa-solid fa-users-viewfinder"></i></div>
                        <h3>Customer Directory</h3>
                        <p>Search your client base instantly via name or phone number. Keep historical records of all past
                            services and payments for VIP treatment.</p>
                    </div>
                    <div className="feature-card reveal" style={{ transitionDelay: '0.3s' }}>
                        <div className="fc-icon color-staff"><i className="fa-solid fa-tags"></i></div>
                        <h3>Create Offers</h3>
                        <p>Attract new users to the Customer App by directly pushing rich promotions and package deals to
                            your salon's live profile.</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FeaturesSection;
